// extracted by mini-css-extract-plugin
export default {"parentContainer":"Home_parentContainer__M5+lc","content":"Home_content__5Mq04"};